import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    loginDialogModal: css({
        [theme.breakpoints.down('lg')]: {
            display: 'none',
        },
    }),
    loginDialogPaper: css({
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%) translateX(-50%)',
        left: '50%',
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            border: 'none',
        }),
    }),
};
